import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SubDomesManagement } from '../modal';

export default function reducer(state: SubDomesManagement = new SubDomesManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUBDOMES_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUBDOMES_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUBDOMES_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
